<template>
    <div class="[ mk-be-organisationindex ] row">
        <div
            class="px-0 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-md-center align-items-start"
            style="margin-bottom: 14px"
        >
            <h2 class="ml-0 mb-3 mb-md-0">Organisations</h2>

            <div class="d-flex flex-column flex-md-row">
                <a
                    :href="`/admin/organisations/create`"
                    @click="$event.target.blur()"
                    class="btn btn-primary mb-3 mb-md-0 ml-md-3"
                >New Organisation</a>
            </div>
        </div>

        <div class="container-fluid mb-4 px-0">
            <div class="row mx-0">
                <div class="col-12 px-0">
                    <paginated-table
                        :headers="headers"
                        :clickablerow="true"
                    >
                    </paginated-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Organisation from "../../models/Organisation";

export default {
    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Business Number (ABN)", value: "abn" },
                { text: "Website", value: "website" },
                {
                    text: "Active Exhibitions",
                    value: "active_exhibitions",
                    formatter: "count",
                    sortable: true,
                },
                {
                    text: "# Artwork",
                    value: "artworks",
                    formatter: "count",
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        async getModelDetails() {
            return Organisation.include("artworks", "activeExhibitions");
        },

        handleRowClick(item) {
            window.location.href = "/admin/organisations/" + item.id + "/edit";
        }
    },
};
</script>
